<div class="row">
  <div class="col-xl-9">
    <div class="card">
      <div class="card-body">
        <div class="border-bottom d-flex justify-content-between">
          <h3>Add Payout Data</h3>
          <h4>3/4</h4>
        </div>

        <div class="row d-flex justify-content-center" [formGroup]="form">
          <div class="col-xl-8 pt-3">
            <div
              *ngIf="form.invalid && form.hasError('ctcExceeded')"
              class="alert alert-danger mt-3"
            >
              Error: The total sum of Basic, PF, and other components marked 'Included in CTC'
              cannot exceed the Total CTC value ({{
                ctc | currency: currency : 'symbol' : '1.0-0' : 'en-IN'
              }}). Please adjust the values. Special Allowance cannot be negative.
            </div>
            <div class="row">
              <label for="ctc" class="col-lg-3 form-label text-lg-end">CTC</label>
              <div class="col-lg-9 font-weight-normal">
                {{ ctc | currency: currency : 'symbol' : '1.0-0' : 'en-IN' }}
              </div>
            </div>
            <div class="row">
              <label for="basic" class="col-lg-3 form-label text-lg-end"
                >Basic <span class="badge bg-soft-info">Earning</span></label
              >
              <!-- <span class="badge bg-soft-info">Info</span> -->
              <div class="col-lg-9">
                <div class="row">
                  <div class="col-md-6">
                    <div class="input-group">
                      <input
                        appTrimInput
                        type="number"
                        class="form-control"
                        [value]="basicPercentage"
                        (input)="updateBasicAmount($event)"
                        placeholder="% of CTC"
                      /><span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <input
                        appTrimInput
                        type="number"
                        class="form-control"
                        (input)="updateBasicPercentage()"
                        formControlName="basic"
                        placeholder="Amount"
                        appIndianNumberInputFormat
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--<div class="row">
              <label for="hra" class="col-lg-3 form-label text-lg-end"
                >HRA <span class="badge bg-soft-info">Earning</span></label
              >
              <div class="col-lg-9">
                <div class="row">
                  <div class="col-md-6">
                    <div class="input-group">
                      <input
                        type="number"
                        class="form-control"
                        [value]="hraPercentage"
                        (input)="updateHraAmount($event)"
                        placeholder="% of CTC"
                      /><span class="input-group-text">%</span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <input
                        type="number"
                        class="form-control"
                        formControlName="hra"
                        (input)="updateHraPercentage()"
                        placeholder="Amount"
                        appIndianNumberInputFormat
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>-->
            <div *ngIf="complianceSettings?.pf" class="row">
              <label for="pf" class="col-lg-3 form-label text-lg-end"
                >PF-Employer Contribution <span class="badge bg-soft-info">Earning</span></label
              >
              <div class="col-lg-9">
                <input
                  appTrimInput
                  type="number"
                  class="form-control"
                  formControlName="pf"
                  appIndianNumberInputFormat
                />
              </div>
            </div>
            <div *ngFor="let itemGroup of inCtcComponents; let i = index" class="row">
              <label for="inCtcComponents" class="col-lg-3 form-label text-lg-end"
                >{{ itemGroup.value.name }}
                <span class="badge bg-soft-info">{{
                  itemGroup.value.componentType === 'customDeductions' ? 'Deduction' : 'Earning'
                }}</span></label
              >
              <div class="col-lg-9">
                <div
                  *ngIf="itemGroup.value.componentType === 'customDeductions'; else elseBlock"
                  class="row"
                >
                  <div class="col-md-5">
                    <div class="input-group">
                      <input
                        appTrimInput
                        type="number"
                        class="form-control"
                        value="{{ getAddedContributionOfEmployer(itemGroup.value) }}"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="mb-3">
                      <input
                        appTrimInput
                        type="number"
                        class="form-control"
                        value="{{ getAddedContributionOfEmployee(itemGroup.value) }}"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="col-md-2">
                    <button
                      type="button"
                      class="btn btn-icon-style ms-3"
                      (click)="removeComponentItem(i)"
                      aria-label="Delete item"
                      data-bs-toggle="tooltip"
                      title="Delete"
                    >
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
                <ng-template #elseBlock>
                  <div class="d-flex align-items-center mb-3">
                    <input
                      appTrimInput
                      type="number"
                      class="form-control"
                      value="{{ getAddedContributionOfEmployer(itemGroup.value) }}"
                      disabled
                    />
                    <button
                      type="button"
                      class="btn btn-icon-style ms-3"
                      (click)="removeComponentItem(i)"
                      aria-label="Delete item"
                      data-bs-toggle="tooltip"
                      title="Delete"
                    >
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="row">
              <label for="specialAllowance" class="col-lg-3 form-label text-lg-end"
                >Special Allowances <span class="badge bg-soft-info">Earning</span></label
              >
              <div class="col-lg-9">
                <input
                  appTrimInput
                  type="number"
                  class="form-control"
                  formControlName="specialAllowance"
                  appIndianNumberInputFormat
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xl-3">
    <div class="card">
      <div class="card-body">
        <!-- <div class="d-flex flex-column list-group settings-list"> -->
        <div class="d-flex flex-column gap-3">
          <button (click)="openModel(addEarningModal)" class="btn btn-primary" type="button">
            + Add Earnings
          </button>
          <button (click)="openModel(addDeductionModal)" class="btn btn-primary" type="button">
            + Add Deductions
          </button>
          <button (click)="openModel(addReimbursementModal)" class="btn btn-primary" type="button">
            + Add Reimbursements
          </button>
        </div>
        <!-- </div> -->
      </div>
    </div>
  </div>
</div>
<!--Componets not in CTC-->
<div *ngIf="notInCtcComponents.length > 0" class="row">
  <div class="col-xl-9">
    <div class="card">
      <div class="card-body">
        <div class="border-bottom d-flex justify-content-between">
          <h3>Components not in CTC</h3>
        </div>
        <div class="row d-flex justify-content-center" [formGroup]="form">
          <div class="col-xl-8 pt-3">
            <div *ngFor="let itemGroup of notInCtcComponents; let i = index" class="row">
              <label for="notInCtcComponents" class="col-lg-3 form-label"
                >{{ itemGroup.value.name }}
                <span class="badge bg-soft-info">{{
                  itemGroup.value.componentType === 'customDeductions' ? 'Deduction' : 'Earning'
                }}</span></label
              >
              <div class="col-lg-9">
                <div
                  *ngIf="itemGroup.value.componentType === 'customDeductions'; else elseBlock"
                  class="row"
                >
                  <div class="col-md-5">
                    <div class="mb-3">
                      <input
                        appTrimInput
                        type="number"
                        class="form-control"
                        value="{{ getAddedContributionOfEmployer(itemGroup.value) }}"
                        disabled
                      />
                      <span class="badge bg-soft-info">Employer Contribution</span>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="mb-3">
                      <input
                        appTrimInput
                        type="number"
                        class="form-control"
                        value="{{ getAddedContributionOfEmployee(itemGroup.value) }}"
                        disabled
                      />
                      <span class="badge bg-soft-info">Employee Contribution</span>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <button
                      type="button"
                      class="btn btn-icon-style ms-3"
                      (click)="removeComponentItem(i)"
                      aria-label="Delete item"
                      data-bs-toggle="tooltip"
                      title="Delete"
                    >
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
                <ng-template #elseBlock>
                  <div class="d-flex align-items-center mb-3">
                    <input
                      appTrimInput
                      type="number"
                      class="form-control"
                      value="{{ getAddedContributionOfEmployer(itemGroup.value) }}"
                      disabled
                    />
                    <button
                      type="button"
                      class="btn btn-icon-style ms-3"
                      (click)="removeComponentItem(i)"
                      aria-label="Delete item"
                      data-bs-toggle="tooltip"
                      title="Delete"
                    >
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xl-3">
    <!--<div class="card">
        <div class="card-body">
        </div>
      </div>-->
  </div>
</div>

<!-- //TODO: Only show Salary Components from Employee's Company -->
<!-- Add Earning Modal -->
<ng-template #addEarningModal let-modal>
  <div class="modal-header header-border justify-content-between m-2">
    <h5 class="modal-title">Add Earnings</h5>
    <button type="button" class="btn-close custom-btn-close" aria-label="Close" (click)="onClose()">
      <i class="ti ti-x"></i>
    </button>
  </div>

  <div class="modal-body m-2">
    <div class="pt-0">
      <p>
        You can select from existing or
        <button
          class="btn btn-link text-primary text-decoration-underline p-0 border-0"
          (click)="openModel(OtherComponentsModal, earningsTabName)"
        >
          create a new earning
        </button>
      </p>
    </div>
    <!-- Search Box -->
    <div class="mb-3">
      <input
        appTrimInput
        type="text"
        class="form-control"
        placeholder="Search earnings..."
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchChange()"
      />
    </div>
    <div class="tab-content">
      <!-- <form [formGroup]="form"> -->
      <div *ngFor="let item of filteredEarnings$ | async" class="form-check">
        <input
          appTrimInput
          class="form-check-input"
          type="radio"
          name="options"
          [value]="item.name"
          (change)="onRadioChange(item)"
          [checked]="selectedComponentItem?.id === item.id"
          [disabled]="isComponentItemAdded(item)"
        />
        <label for="addedAmount" class="form-check-label">
          {{ item.name }}
        </label>
        <div *ngIf="isComponentItemAdded(item)">
          <small>Added Amount: {{ getAddedContributionOfEmployer(item) }}</small>
          <button type="button" class="btn btn-sm text-primary ms-2" (click)="startEditing(item)">
            <i class="ti ti-edit"></i>
          </button>
          <button
            type="button"
            class="btn btn-sm p-0 text-danger"
            (click)="removeComponentItemFromModal(item)"
          >
            <i class="ti ti-trash"></i>
          </button>
        </div>

        <!-- If this item is selected (and not already added), show the input field immediately below -->
        <div *ngIf="selectedComponentItem?.id === item.id">
          <input
            appTrimInput
            type="number"
            class="form-control"
            placeholder="Enter Amount"
            [(ngModel)]="employerContribution"
            required
          />
        </div>
      </div>
      <div *ngIf="addCompError" class="alert alert-warning" role="alert">{{ addCompError }}</div>
      <button
        *ngIf="(earnings$ | async)?.length"
        type="button"
        class="btn btn-primary wizard-next-btn"
        (click)="addComponentItem()"
        [disabled]="!selectedComponentItem"
      >
        {{ isEditing ? 'Update' : 'Add' }}
      </button>
      <!-- </form> -->
    </div>
  </div>
</ng-template>
<!-- /Add Earning Modal -->

<!-- Add Deduction Modal -->
<ng-template #addDeductionModal let-modal>
  <div class="modal-header header-border justify-content-between m-2">
    <h5 class="modal-title">Add Deductions</h5>
    <button type="button" class="btn-close custom-btn-close" aria-label="Close" (click)="onClose()">
      <i class="ti ti-x"></i>
    </button>
  </div>

  <div class="modal-body m-2">
    <div class="pt-0">
      <p>
        You can select from existing or
        <button
          class="btn btn-link text-primary text-decoration-underline p-0 border-0"
          (click)="openModel(OtherComponentsModal, deductionsTabName)"
        >
          create a new deduction
        </button>
      </p>
    </div>
    <!-- Search Box -->
    <div class="mb-3">
      <input
        appTrimInput
        type="text"
        class="form-control"
        placeholder="Search deductions..."
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchChange()"
      />
    </div>
    <div class="tab-content">
      <div *ngFor="let item of filteredDeductions$ | async" class="form-check">
        <input
          appTrimInput
          class="form-check-input"
          type="radio"
          name="options"
          [value]="item.name"
          (change)="onRadioChange(item)"
          [checked]="selectedComponentItem?.id === item.id"
          [disabled]="isComponentItemAdded(item)"
        />
        <label for="preTax" class="form-check-label">
          {{ item.name }} <span class="badge bg-soft-info">Pre-Tax</span>
        </label>
        <div *ngIf="isComponentItemAdded(item)">
          <small>Employer Contribution: {{ getAddedContributionOfEmployer(item) }}, </small>
          <small>Employee Contribution: {{ getAddedContributionOfEmployee(item) }}</small>
          <button type="button" class="btn btn-sm text-primary ms-2" (click)="startEditing(item)">
            <i class="ti ti-edit"></i>
          </button>
          <button
            type="button"
            class="btn btn-sm p-0 text-danger"
            (click)="removeComponentItemFromModal(item)"
          >
            <i class="ti ti-trash"></i>
          </button>
        </div>

        <!-- If this item is selected (and not already added), show the input field immediately below -->
        <div *ngIf="selectedComponentItem?.id === item.id">
          <input
            appTrimInput
            type="number"
            class="form-control"
            placeholder="Employer's Contribution"
            [(ngModel)]="employerContribution"
            required
          />
          <input
            appTrimInput
            type="number"
            class="form-control"
            placeholder="Employee's Contribution"
            [(ngModel)]="employeeContribution"
            required
          />
        </div>
      </div>
      <div *ngIf="addCompError" class="alert alert-warning" role="alert">{{ addCompError }}</div>
      <button
        *ngIf="(deductions$ | async)?.length"
        type="button"
        class="btn btn-primary wizard-next-btn"
        (click)="addComponentItem()"
        [disabled]="!selectedComponentItem"
      >
        {{ isEditing ? 'Update' : 'Add' }}
      </button>
    </div>
  </div>
</ng-template>
<!-- /Add Deduction Modal -->

<!-- Add Reimbursements Modal -->
<ng-template #addReimbursementModal let-modal>
  <div class="modal-header header-border justify-content-between m-2">
    <h5 class="modal-title">Add Reimbursements</h5>
    <button type="button" class="btn-close custom-btn-close" aria-label="Close" (click)="onClose()">
      <i class="ti ti-x"></i>
    </button>
  </div>

  <div class="modal-body m-2">
    <div class="pt-0">
      <p>
        You can select from existing or
        <button
          class="btn btn-link text-primary text-decoration-underline p-0 border-0"
          (click)="openModel(OtherComponentsModal, reimbursementsTabName)"
        >
          create a new reimbursement
        </button>
      </p>
    </div>
    <!-- Search Box -->
    <div class="mb-3">
      <input
        appTrimInput
        type="text"
        class="form-control"
        placeholder="Search reimbursements..."
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchChange()"
      />
    </div>
    <div class="tab-content">
      <div *ngFor="let item of filteredReimbursements$ | async" class="form-check">
        <input
          appTrimInput
          class="form-check-input"
          type="radio"
          name="options"
          [value]="item.name"
          (change)="onRadioChange(item)"
          [checked]="selectedComponentItem?.id === item.id"
          [disabled]="isComponentItemAdded(item)"
        />
        <label for="addedAmount" class="form-check-label">
          {{ item.name }}
        </label>
        <div *ngIf="isComponentItemAdded(item)">
          <small>Added Amount: {{ getAddedContributionOfEmployer(item) }}</small>
          <button type="button" class="btn btn-sm text-primary ms-2" (click)="startEditing(item)">
            <i class="ti ti-edit"></i>
          </button>
          <button
            type="button"
            class="btn btn-sm p-0 text-danger"
            (click)="removeComponentItemFromModal(item)"
          >
            <i class="ti ti-trash"></i>
          </button>
        </div>

        <!-- If this item is selected (and not already added), show the input field immediately below -->
        <div *ngIf="selectedComponentItem?.id === item.id">
          <input
            appTrimInput
            type="number"
            class="form-control"
            placeholder="Enter Amount"
            [(ngModel)]="employerContribution"
            required
          />
        </div>
      </div>
      <div *ngIf="addCompError" class="alert alert-warning" role="alert">{{ addCompError }}</div>
      <button
        *ngIf="(reimbursements$ | async)?.length"
        type="button"
        class="btn btn-primary wizard-next-btn"
        (click)="addComponentItem()"
        [disabled]="!selectedComponentItem"
      >
        {{ isEditing ? 'Update' : 'Add' }}
      </button>
    </div>
  </div>
</ng-template>
<!-- /Add Reimbursements Modal -->
